module.exports = __webpack_public_path__ + "img/schoonmeersen.0a83711f.jpg";